import { API_URL } from '../../config';
import { toApiError } from '../../lib/api-error';
import type { EnvironmentItem } from '../../ui/components/property-tabs/propertyEnvironmentPresentation';

export async function fetchPropertyEnvironments(propertyId: string): Promise<{ items: EnvironmentItem[] }> {
  const res = await fetch(`${API_URL}/org/properties/${propertyId}/environments`, {
    credentials: 'include',
  });
  if (!res.ok) throw await toApiError(res, 'Failed to load environments');
  return res.json();
}
